// extracted by mini-css-extract-plugin
module.exports = {"hgroup__heading":"_dG","hgroup__subheading":"_dH","hgroup":"_dI"};